<template>
  <div id="commission-invoices" class="px-4 py-4">
    <commission-invoice-list />
  </div>
</template>
<script>
import CommissionInvoiceList from "@/components/finance/CommissionInvoiceList.vue";
export default {
  components: {
    CommissionInvoiceList
  }
};
</script>
